import * as React from 'react'
import {
  Theme,
  createStyles,
  WithStyles,
  withStyles
} from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import {
  IChecklist,
  IChecklistField,
  IChecklistGroup,
  IChecklistRenderProps,
  IPhoto
} from '../../models/Checklist'
import { isLocalImage } from '../../data_sources/imagestorage/imageStorage'
import QuestionGroup from '../checklists/QuestionGroup'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../OneplaceLibraryProvider'
import CardContent from '@material-ui/core/CardContent'
import { Typography } from '@material-ui/core'
import FormWrapperCheckButton from '../form_wrapper/FormWrapperCheckButton'
import { TemplateTypes } from '../../models/Template'
import { IUserCapabilities } from '../..'

const styles = (theme: Theme) =>
  createStyles({
    tabWarningIcon: {
      width: 20,
      height: 20,
      marginLeft: 6,
      color: theme.palette.secondary.main
    },
    tabLight: {
      background: theme.palette.primary.light,
      color: '#fff'
    }
  })

export interface ITicketChecklistProps
  extends WithStyles<typeof styles>,
    IOneplaceLibraryContextProp {
  checklist: IChecklist
  renderProps: IChecklistRenderProps
  onChecklistChange: (groupIndex: number, fieldId: number) => void
  validateConditionalQuestion: (
    newValue: string,
    question: IChecklistField | null
  ) => void
  getControlQuestionValue: (groupId: number, questionId: number) => number

  // conditional questions need refresh
  questionsNeedRefresh: boolean
  disableTabs?: boolean

  refreshFormulaQuestions: (inputQuestion: IChecklistField) => void

  selectedGroupIdx: number
  useTabs: boolean
}

export interface ITicketChecklistState {
  selectedTabIdx: number
  selectedGroupIdx: number
  disableTabs: boolean
  capabilities: IUserCapabilities | null
}

export const TicketChecklistTab = withStyles(styles)(
  withOneplaceLibraryContext(
    // eslint-disable-next-line react/display-name
    class extends React.Component<
      ITicketChecklistProps,
      ITicketChecklistState
    > {
      timer: any = null
      groupsToShow: IChecklistGroup[] = []

      constructor(props: any) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.nextTab = this.nextTab.bind(this)
        this.prevousTab = this.prevousTab.bind(this)
        this.groupsToShow = this.props.checklist.groups.filter(
          (_group, index) => {
            return this.props.renderProps.groups[index].showTab
          }
        )
        this.state = {
          selectedTabIdx: 0,
          selectedGroupIdx: 0,
          disableTabs: this.props.disableTabs ? this.props.disableTabs : false,
          capabilities: null
        }
      }

      async componentDidMount() {
        const caps = await this.props.ctx.client.getCapabilities()
        this.setState({ capabilities: caps })
      }

      componentWillReceiveProps = (nextProps: ITicketChecklistProps) => {
        this.setState({
          disableTabs: nextProps.disableTabs ? nextProps.disableTabs : false
        })
      }

      handleChange(_event: any, value: any) {
        let selectedGroupOffset: number
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        selectedGroupOffset = value
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const selectedGroup = this.groupsToShow[value]
        selectedGroupOffset = this.props.checklist.groups.findIndex((group) => {
          return group.id == selectedGroup.id
        })
        this.setState({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          selectedTabIdx: value,
          selectedGroupIdx: selectedGroupOffset
        })
      }

      nextTab() {
        if (
          this.state.selectedTabIdx <
          this.props.checklist.groups.length - 1
        ) {
          let selectedGroupOffset: number
          selectedGroupOffset = this.state.selectedTabIdx + 1
          const selectedGroup = this.groupsToShow[this.state.selectedTabIdx + 1]
          selectedGroupOffset = this.props.checklist.groups.findIndex(
            (group) => {
              return group.id == selectedGroup.id
            }
          )
          this.setState({
            selectedTabIdx: this.state.selectedTabIdx + 1,
            selectedGroupIdx: selectedGroupOffset
          })
        }
      }

      prevousTab() {
        if (this.state.selectedTabIdx > 0) {
          let selectedGroupOffset: number
          selectedGroupOffset = this.state.selectedTabIdx - 1
          const selectedGroup = this.groupsToShow[this.state.selectedTabIdx - 1]
          selectedGroupOffset = this.props.checklist.groups.findIndex(
            (group) => {
              return group.id === selectedGroup.id
            }
          )
          this.setState({
            selectedTabIdx: this.state.selectedTabIdx - 1,
            selectedGroupIdx: selectedGroupOffset
          })
        }
      }

      onDeletePhoto = (photo: IPhoto) => {
        if (!isLocalImage(photo.url) && photo.id) {
          let deletedPhotos = this.props.checklist.deletedPhotos
          if (deletedPhotos === null || deletedPhotos === undefined) {
            deletedPhotos = []
            this.props.checklist.deletedPhotos = deletedPhotos
          }
          if (!(photo.id in deletedPhotos)) {
            deletedPhotos.push(photo.id)
          }
        }
      }

      render() {
        const { capabilities } = this.state

        if (!capabilities) {
          return null
        }
        this.groupsToShow = this.props.checklist.groups.filter(
          (_group, index) => {
            return this.props.renderProps.groups[index].showTab
          }
        )

        return (
          <React.Fragment>
            {this.groupsToShow.length > 0 &&
              this.groupsToShow.map((group, idx) => {
                let groupIndex = 0
                for (let i = 0; i < this.props.checklist.groups.length; i++) {
                  if (this.props.checklist.groups[i].id == group.id) {
                    groupIndex = i
                    break
                  }
                }
                const renderProps = this.props.renderProps.groups[groupIndex]
                return (
                  <div
                    key={idx}
                    id={group.label}
                    data-watch-id={idx}
                    style={{
                      display: !this.props.useTabs
                        ? 'block'
                        : this.props.selectedGroupIdx === idx
                        ? 'block'
                        : 'none'
                    }}
                  >
                    {!this.props.useTabs && (
                      <Card
                        className={this.props.classes.tabLight}
                        style={{
                          display: !this.state.disableTabs ? 'block' : 'none'
                        }}
                      >
                        <CardContent style={{ background: '#5567a8' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              background: '#5567a8'
                            }}
                          >
                            <Typography>{group.label}</Typography>
                            {!renderProps.incompleteFields && (
                              <FormWrapperCheckButton />
                            )}
                          </div>
                        </CardContent>
                      </Card>
                    )}
                    <QuestionGroup
                      groupIndex={groupIndex}
                      group={this.props.checklist.groups[groupIndex]}
                      renderProps={this.props.renderProps.groups[groupIndex]}
                      onFieldChange={this.props.onChecklistChange}
                      onTicketPreset={() =>
                        alert(
                          'Ticket presets on ticket checklists not currently supported.'
                        )
                      }
                      validateConditionalQuestion={
                        this.props.validateConditionalQuestion
                      }
                      questionsNeedRefresh={this.props.questionsNeedRefresh}
                      dateTimeFormat={capabilities.dateTimeFormat}
                      dateFormat={capabilities.dateFormat}
                      fullName={capabilities.username}
                      hideGroupPhotos={this.props.checklist.hideGroupPhotos}
                      onDeletePhoto={this.onDeletePhoto}
                      allowSavedPhotoDeletion={true}
                      allowPhotosFromGallery={capabilities.usePhotoGallery}
                      refreshFormulaQuestions={
                        this.props.refreshFormulaQuestions
                      }
                      getControlQuestionValue={
                        this.props.getControlQuestionValue
                      }
                      templateType={TemplateTypes.CHECKLIST}
                    />
                  </div>
                )
              })}
          </React.Fragment>
        )
      }
    }
  )
)
